// Helper function to check if Klaviyo is loaded
export const isKlaviyoLoaded = () => {
  return typeof window !== "undefined" && window._learnq;
};

// Helper function to identify a user
export const identifyUser = (email, properties = {}) => {
  if (!isKlaviyoLoaded()) {
    console.warn("Klaviyo not loaded");
    return;
  }

  window._learnq.push([
    "identify",
    {
      $email: email,
      ...properties,
    },
  ]);
};

// Helper function to track an event
export const trackEvent = (eventName, properties = {}) => {
  if (!isKlaviyoLoaded()) {
    console.warn("Klaviyo not loaded");
    return;
  }

  window._learnq.push(["track", eventName, properties]);
};

// Helper function to show a specific form
export const showKlaviyoForm = (formId) => {
  if (typeof window === "undefined" || !window._klOnsite) {
    console.warn("Klaviyo form API not loaded");
    return;
  }

  window._klOnsite.push(["openForm", formId]);
};
